import { gsap } from 'gsap';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import ScrollItem__BlockDefault from './ScrollItem__BlockDefault';
import { SliderScroll } from '../_app/cuchillo/components/SliderScroll';
import Scroll_Item from '../_app/cuchillo/scroll/Scroll_Item';
import { Icon } from '../components/Icon';
import { GetBy } from '../_app/cuchillo/core/Element';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { isTouch } from '../_app/cuchillo/core/Basics';


// ─── Slide item ───────────────────────────────────────────────────────────────
// Each slide creates Icon instances for its [data-svg-star] elements.
// show() reveals the stars with a 0.05s stagger.

class ScrollItem__BlockReviews__Slide extends VScroll_Item {
  _icons = [];

  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    this._icons = [...GetBy.selector('[data-svg-star]', __link)];
    gsap.set(this._icons, { opacity: 0 });
  }

  show() {
    super.show();
    this._icons.forEach((icon, i) => { gsap.to(icon, { opacity: 1, duration: .2, delay: .5 + i * .05 }) });
  }

  dispose() {
    this._icons = [];
    super.dispose();
  }
}


// ─── Block ────────────────────────────────────────────────────────────────────

class ScrollItem__BlockReviews extends ScrollItem__BlockDefault {
  _call;
  _slider;

  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    // Amb només 3 reviews (el mínim que garanteix block_reviews.njk) no hi ha res a lliscar:
    // deshabilitem drag + les 2 fletxes. Amb 4+ funciona normal.
    const slides = GetBy.class('block-reviews__item', __link).length;
    const locked = slides <= 3;

    // interaction (MrInteraction, drag JS): NOMÉS a desktop. En mòbil el CSS ja fa
    // overflow-x:auto + scroll-snap (veure _block-reviews.scss) — si deixem el drag
    // JS actiu, fa preventDefault() sobre el tàctil i lluita amb el scroll-snap
    // natiu pel mateix gest (2 sistemes movent el mateix element alhora).
    this._slider = new SliderScroll(__link, {
      interaction: !locked && !isTouch,
      hasScrollbar: false,
      itemClass: ScrollItem__BlockReviews__Slide
    });

    if (locked) {
      const prev = GetBy.class('block-reviews__prev', __link)[0];
      const next = GetBy.class('block-reviews__next', __link)[0];
      if (prev) prev.classList.add('disabled');
      if (next) next.classList.add('disabled');
      // Evita que SliderScroll.loop() les torni a togglejar per posició: si _controls.prev/next
      // no existeixen, el loop les ignora (guards) → queden disabled fixes.
      if (this._slider._controls) { this._slider._controls.prev = null; this._slider._controls.next = null; }
    }

    this._call = () => this.loop();

    this.onShow = () => {
      gsap.ticker.add(this._call);
    };

    this.onHide = () => {
      gsap.ticker.remove(this._call);
    };
  }

  loop() {
    if (this._slider) this._slider.loop();
  }

  resize(w, h) {
    super.resize(w, h);
    if (this._slider) this._slider.resize();
  }

  dispose() {
    if (this._slider) this._slider.dispose();
    super.dispose();
  }
}

Scroll._registerClass('BlockReviews', ScrollItem__BlockReviews);

export default ScrollItem__BlockReviews;
